import { urlFor } from "@/utils/client";
import { IProcess } from "@/utils/types";
import Image from "next/image";

export function Process(props: IProcess) {
  console.log(props);

  return (
    <div className="component-padding ">
      <div
        style={{}}
        className={`grid grid-cols-1 ${props.invert ? `bg-white text-darkGrey` : `bg-darkGrey text-white`} md:grid-cols-2 component-gap p-8 `}
      >
        <div className="flex flex-col component-gap">
          <p className="heading">{props.title}</p>
          <p>{props.description}</p>
          {props.items?.length > 0 && (
            <div className="flex flex-col gap-4">
              {props.items.map((item, i) => {
                return (
                  <div
                    key={i}
                    className={`grid grid-cols-[auto_1fr] gap-4 items-center justify-start border-b ${props.invert ? `border-darkGrey/10` : `border-white/10`} pb-4`}
                  >
                    <p
                      className={`font-display !w-[40px] !h-[40px] opacity-80 flex items-center justify-center rounded-full border ${props.invert ? `boder-darkGrey/50` : `border-white/10`}`}
                    >
                      {i + 1}
                    </p>
                    <p className="text-xl opacity-80">{item}</p>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        {props.image?.image && (
          <Image
            width={500}
            height={500}
            alt={props.image?.caption ?? ""}
            src={urlFor(props.image.image).url()}
            className="w-full h-full object-cover aspect-square"
          />
        )}
      </div>
    </div>
  );
}
